import { controlService } from "./requests.ts";
import { toast } from 'react-toastify';
import { store } from "../../Redux/Store";
import { ChangeCards, ChangeGraphData, LogOut } from "../../Redux/Actions/index.js";
import i18n from "../../Config/i18n.js";
export class DetailsController{
    constructor() {
        this.data = [];
        this.scale = {
            max: null,
            min: null,
        }
    }

    // Função para exibir os cards
    ShowCards(element){
        if(element.cards_comando.comandoPoco.active){
            let tempCards = [];
            if(element.cards_comando.grupos.length > 0){
                element.cards_comando.grupos.map(grupo => {
                    tempCards.push({
                        maintenance : element.maintenance,
                        grupo: grupo,
                        switchvariable: element.cards_comando.switchvariable
                    });
                    return grupo;
                })
            }
            element.cards_comando.comando_variavel.map(item => {
                tempCards.push({...item, maintenance : element.maintenance});
                return item;
            })
            let cards = {
                id : element.id,
                name : element.cards_comando.name,
                cards: tempCards,
                active : element.cards_comando.comandoPoco.active
            }
            let color = this.getCardColor(tempCards[0])
            this.StartGraph(tempCards[0], null, color)
            store.dispatch(ChangeCards(JSON.parse(JSON.stringify(cards))))
        }else{
            toast(i18n.t("message.detailsController.show-cards"), {
                position: "top-center",
                type: 'info',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
        }
    }

    // Função para inicia o gráfico
    async StartGraph(card, time, color, keepScale){
        let ids = [];
        let names = [];
        let poco = store.getState().generalReducer.Equipament;
        let min = null;
        let max = null;
        let name
        if(card.grupo){
            name = card.grupo.name
            let grupos = JSON.parse(JSON.stringify(card.grupo.variaveis_agrupadas))
            grupos = grupos.sort((a, b) => b?.variavel?.name.localeCompare(a?.variavel?.name));
            grupos.map(variavel => {
                if(grupos[0].variavel.isSwitch){
                    ids.push(variavel.variavel.id);
                    names.push(variavel.variavel.name);
                    min = min < variavel.variavel.min ? min : variavel.variavel.min ? variavel.variavel.min : min;
                    max = max > variavel.variavel.max ? max : variavel.variavel.max ? variavel.variavel.max : max;
                    return variavel;
                }
                if(variavel.variavel.name.toLowerCase().includes('vazão')){
                    ids.push(variavel.variavel.id);
                    names.push(variavel.variavel.name);
                    min = min < variavel.variavel.min ? min : variavel.variavel.min ? variavel.variavel.min : min;
                    max = max > variavel.variavel.max ? max : variavel.variavel.max ? variavel.variavel.max : max;
                }
                if(variavel.variavel.name.toLowerCase().includes('cloro') || variavel.variavel.name.toLowerCase().includes('fluoreto')){
                    min = min < variavel.variavel.min ? min : variavel.variavel.min ? variavel.variavel.min : min;
                    max = max > variavel.variavel.max ? max : variavel.variavel.max ? variavel.variavel.max : max;
                    ids.push(variavel.variavel.id);
                    names.push(variavel.variavel.name);
                }
                if(variavel.variavel.abbreviation === 'SP' && !ids.includes(variavel.variavel.id)){
                    ids.push(variavel.variavel.id);
                    names.push(variavel.variavel.name);
                }
                return variavel;
            })

        }else{
            name = card.variavel.name
            min = min < card.variavel.min ? min : card.variavel.min ? card.variavel.min : min
            max = max > card.variavel.max ? max : card.variavel.max ? card.variavel.max : max
            ids.push(card.variavel.id)
            names.push(card.variavel.name)
        }
        store.dispatch(ChangeGraphData({
            name : name,
            dados: [
                {
                    Loading : true,
                    id: '',
                    data: []
                }
            ],
            max: 0,
            min: 0,
        }));
        keepScale && this.scale.min !== null ? min = this.scale.min : this.scale.min = null;
        keepScale && this.scale.max !== null ? max = this.scale.max : this.scale.max = null;

        let dados = {
            name : name,
            dados: [],
            Loading : false,
            max: max,
            min: min === null ? 0 : min,
        };
        time = time ? JSON.parse(JSON.stringify(time)) : JSON.parse(JSON.stringify(store.getState().controlReducer.time))
        for(let i=0; i<ids.length; i++){
            try {
                let formated = await this.getIdValues(poco, ids[i], time, names[i], color);
                dados.dados.push(formated);
            } catch (error) {
                console.log(error)
            }
        }
        if(dados?.dados[0]){
            dados.dados[0].Loading = false;
        }
        store.dispatch(ChangeGraphData(JSON.parse(JSON.stringify(dados))));
    }

    async getIdValues(equipamentId, variavelId, time, name, color){
        let dado = {
            dados: [],
            time: parseInt(time)
        };
        if(localStorage.hasOwnProperty(equipamentId + '-' + variavelId + '-' + time) && localStorage.getItem(equipamentId + '-' + variavelId + '-' + time) !== null){
            dado = JSON.parse(localStorage.getItem(equipamentId + '-' + variavelId + '-' + time));
            let timeDiff = dado?.dados?.length > 0 ? new Date().valueOf() - new Date(dado.dados[dado.dados.length-1].created_at).valueOf() : 360001;
            if(dado?.dados?.length < 1 || (timeDiff > 360000) || parseInt(dado.time) !== parseInt(time)){
                dado.dados = await this.RequestGraph(equipamentId, variavelId, time);
                dado.time = parseInt(time);
            }
        }else{
            dado.dados = await this.RequestGraph(equipamentId, variavelId, time);
        }
        try {
            localStorage.setItem(equipamentId + '-' + variavelId + '-' + time, JSON.stringify(dado));
        } catch (error) {
            console.log(error)
        }
        let formated = await this.formatDado(dado.dados, name, color);
        return formated;
    }

    // Função para fazer o request dos dados
    async RequestGraph (poco, id, time){
        try {
            let response = await controlService.getGraphData(poco, id, time);
            return response.values;
        } catch (error) {
            console.log(error)
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
        }
        return [];
    }

    // Função para formata os dados
    async formatDado(dado, name, color){
        let dadoFormatado = [];
        dadoFormatado = dado.map(info => {
            return{
                y: info.value,
                x: info.created_at,
            }
        });
        let com = store.getState().controlReducer.lastUpdate.Comunicacao
        if(com === 3){
            color = '#6600CC';
        }
        return {
            id: name,
            data: dadoFormatado,
            color: color
        }
    }

    // Função para pegar a cor do card
    getCardColor(card){
        let color
        if(card?.grupo){
            color = this.getAlarm(card.grupo.variaveis_agrupadas[0].variavel.valor, card.grupo.variaveis_agrupadas[0].variavel.alarmL?.variavel.valor,
                card.grupo.variaveis_agrupadas[0].variavel.alarmLL?.variavel.valor, card.grupo.variaveis_agrupadas[0].variavel.alarmH?.variavel.valor,
                card.grupo.variaveis_agrupadas[0].variavel.alarmHH?.variavel.valor, card.grupo.variaveis_agrupadas[0].variavel.name.includes('Bomba'))
        }else{
            color = this.getAlarm(card.variavel.valor, card.variavel.alarmL?.variavel.valor,
                card.variavel.alarmLL?.variavel.valor, card.variavel.alarmH?.variavel.valor,
                card.variavel.alarmHH?.variavel.valor)
        }
        color = card.maintenance === '1' ? color = '#E1800E' : color === 6 ? '#00375E' : color === 2 ? '#FF3939' : color === 1 ? '#EABC1A' : color === 0 ? '#3C9' : '#006560';
        return color;
    }

    // Função para pegar o alarme
    getAlarm (valor, l, ll, h, hh, bomba){
        if(ll != null && (hh === null || hh === undefined) && ll === l){
            return 6;
        }
        if(hh != null && (ll === null || ll === undefined) && hh === h){
            return 6;
        }
        if(hh === h && ll === l && hh === ll){
            return 6;
        }
        if(ll != null && bomba ? parseFloat(ll) !== 0 : true){
            if (valor <= ll){
                return 2;
            }
        }
        if(hh != null && bomba ? parseFloat(hh) !== 0 : true){
            if (valor >= hh){
                return 2;
            }
        }
        if(l != null){
            if (valor <= l){
                return 1;
            }
        }
        if(h != null){
            if (valor >= h){
                return 1;
            }
        }
        return 0;
    }

    // Função para buscar o nivel de alerta
    getAlarmColor = (valor, l, ll, h, hh, Comunicacao, bomba) => {
        if(Comunicacao === 3){
            return '#6600CC';
        }else if(Comunicacao === 4){
            return '#E1800E';
        }
        if(ll != null && (hh === null || hh === undefined) && ll === l){
            return '#006560'
        }
        if(hh != null && (ll === null || ll === undefined) && hh === h){
            return '#006560'
        }
        if(hh === h && ll === l && hh === ll){
            return '#006560'
        }
        if(ll != null && bomba ? parseFloat(ll) !== 0 : true){
            if (parseFloat(valor) <= parseFloat(ll)){
                return '#FF3939';
            }
        }
        if(hh != null  && bomba ? parseFloat(hh) !== 0 : true){
            if (parseFloat(valor) >= parseFloat(hh)){
                return '#FF3939';
            }
        }
        if(l != null){
            if (parseFloat(valor) <= parseFloat(l)){
                return '#EABC1A';
            }
        }
        if(h != null){
            if (parseFloat(valor) >= parseFloat(h)){
                return '#EABC1A';
            }
        }
        return '#3C9';
    }

    changeScale(min, max){
        this.scale = {
            min : min ? min : this.scale.min,
            max : max ? max : this.scale.max,
        }
    }
}